import { RawHtml } from '~/shared/components/RawHtml';
import React from 'react';
import { M100RichTextModule } from '~/lib/data-contract';
import { useModuleTheme } from '../../hooks/useModuleTheme';
import { ModuleContainer } from '../ModuleContainer';
import { ModuleHeader } from '../ModuleHeader';

export type M100RichTextProps = M100RichTextModule;

export const M100RichText = ({
    text,
    headline,
    subHeadline,
    subSubHeadline,
    ...rest
}: M100RichTextProps) => {
    const { textColor } = useModuleTheme(rest);

    return (
        <ModuleContainer hasGutter {...rest}>
            <ModuleHeader
                headline={headline}
                subHeadline={subHeadline}
                subSubHeadline={subSubHeadline}
                textColor={textColor}
            />
            <div style={{ color: textColor }}>
                {text && <RawHtml style={{ color: textColor }} html={text} />}
            </div>
        </ModuleContainer>
    );
};
